<script lang="ts">
  import * as AlertDialog from "$lib/components/ui/alert-dialog/index.js";
  import { Label } from "$lib/components/ui/label";
  import {
    projectFormErrors,
    ProjectFormSection,
  } from "$src/application/projects/stores/projectStore";
  import { t } from "svelte-i18n";

  export let open: boolean;
  export let allowContinueAction: boolean = false;
  export let onContinueAction: () => void | undefined;
  export let description: string | undefined = undefined;

  function cancelFormErrorsAlert() {
    open = false;
  }
</script>

<AlertDialog.Root bind:open>
  <AlertDialog.Content>
    <AlertDialog.Header>
      <AlertDialog.Title>
        {$t("page.projects.detail.errors-title")}
      </AlertDialog.Title>
      {#if description}
        <AlertDialog.Description>
          {description}
        </AlertDialog.Description>
      {/if}
    </AlertDialog.Header>

    {JSON.stringify($projectFormErrors)}
    {#each $projectFormErrors as { section, errors }}
      {#each errors as error}
        <div>
          <Label>
            {#if section == ProjectFormSection.Info}
              {$t("page.projects.detail.info-title")}
            {:else if section == ProjectFormSection.InfoCustomer}
              {$t("page.projects.detail.info-customer-title")}
            {:else if section == ProjectFormSection.Amounts}
              {$t("page.projects.detail.amounts.title")} / {$t(
                "page.projects.detail.schedule.title"
              )}
            {/if}
          </Label> :
          <Label class="font-normal">{$t(error)}</Label>
        </div>
      {/each}
    {/each}

    <AlertDialog.Footer>
      {#if allowContinueAction && onContinueAction}
        <AlertDialog.Cancel on:click={onContinueAction}>
          {$t("page.projects.detail.ignore-errors")}
        </AlertDialog.Cancel>
      {/if}
      <AlertDialog.Action on:click={cancelFormErrorsAlert}>
        {$t("page.projects.detail.fix-errors")}
      </AlertDialog.Action>
    </AlertDialog.Footer>
  </AlertDialog.Content>
</AlertDialog.Root>
